import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const SidebarLink = styled(Link)`
  display: flex;
  color: #e1e9fc;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;
  
  &:hover {
    background: #fff;
    border-left: 4px solid green;
    cursor: pointer;
    color: #185F6F;
  }
`;

const SidebarNav = styled.div`
  display: flex;
  color: #e1e9fc;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;
  
  &:hover {
    background: #fff;
    border-left: 4px solid green;
    cursor: pointer;
    color: #185F6F;
  }
`;

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const DropdownLink = styled(Link)`
  background: #252831;
  height: 60px;
  padding-left: 3rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #f5f5f5;
  font-size: 18px;
  
  &:hover {
    background: green;
    cursor: pointer;
  }
`;

const SubMenu = ({ item }) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);

  return (
    <>
      {
        item?.subNav?.length > 0 ?
        <SidebarNav
        onClick={item.subNav && showSubnav}>
        <div className="is-flex is-align-items-center">
          {item.icon}
          <SidebarLabel>{item.title}</SidebarLabel>
        </div>
        <div>
          {item.subNav && subnav
            ? item.iconOpened 
            : item.subNav 
              ? item.iconClosed
              : null}
        </div>
      </SidebarNav>:
        <SidebarLink to={item.path}
        onClick={item.subNav && showSubnav}>
        <div className="is-flex is-align-items-center">
          {item.icon}
          <SidebarLabel>{item.title}</SidebarLabel>
        </div>
        <div>
          {item.subNav && subnav
            ? item.iconOpened 
            : item.subNav 
              ? item.iconClosed
              : null}
        </div>
      </SidebarLink>
      
      }
      {subnav &&
        item.subNav.map((item, index) => {
          return (
            <DropdownLink style={{background:"#185F6F"}} to={item.path} key={index} className>
              {item.icon}
              <SidebarLabel>{item.title}</SidebarLabel>
            </DropdownLink>
          );
        })}
    </>
  );
};

export default SubMenu;